module.exports = __webpack_public_path__ + "static/img/btn2.6d1012c1.png";